<div mat-dialog-title>
  <p>{{ 'quickstart.modal.' + data + '.header' | translate }}</p>
  <mat-icon mat-dialog-close class="close" data-testid="quickstart-modal-close-btn">close</mat-icon>
</div>
<mat-dialog-content>
  <p>{{ 'quickstart.modal.' + data + '.description' | translate }}</p>
</mat-dialog-content>
